import { render, staticRenderFns } from "./CarManage.vue?vue&type=template&id=da133980&scoped=true&"
import script from "./CarManage.vue?vue&type=script&lang=js&"
export * from "./CarManage.vue?vue&type=script&lang=js&"
import style0 from "./CarManage.vue?vue&type=style&index=0&id=da133980&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da133980",
  null
  
)

export default component.exports